// eslint-disable-next-line unicorn/filename-case
import React from 'react';

interface CheckboxProperties {
  row?: {
    original?: {
      isDefault?: boolean;
    };
  };
}
export function DefaultCheckbox(properties: CheckboxProperties) {
  // eslint-disable-next-line react/destructuring-assignment
  const checked = properties.row?.original?.isDefault === true;
  return (
    <input
      type="checkbox"
      checked={checked}
      disabled
      style={{ cursor: 'not-allowed' }}
      readOnly
    />
  );
}